import "./Tag.css";

export const Tag = ({ tag, withoutBorders }) => {
	return (
		<div className={`tag ${withoutBorders ? 'without-borders' : ''}`} style={{ '--tagColor': tag.color }}>
			<span>{tag.name}</span>
		</div>
	);
}